export const table_config = {
  actions: {
    single: (lead) => [[{ label: 'View', value: 'view', hidden: !lead }]]
  },
  css: {},
  fields: [
    {
      title: 'Name',
      key: 'name',
      isTitle: true,
      searchable: true
    },
    {
      title: 'Industry',
      key: 'industry',
      isTagline: true,
      searchable: true
    },
    {
      title: 'Location',
      key: 'location',
      isTagline: true
    },
    {
      title: 'Score',
      key: 'score',
      isTagline: true,
      formatter: (value) => (value || value === 0 ? `★ ${value}` : '—')
    },
    {
      title: 'Stage',
      key: 'status_slug',
      isTagline: true
    },
    {
      title: 'Date added',
      key: 'created_on',
      formatter: (value) => (value ? new Date(value).toDateString() : ''),
      isMetadata: true
    }
  ],
  items: [],
  search_key: 'name',
  search_text: 'Search leads'
};
